import { aiAgentApis } from '../../../../../../shared/apis/ai-agent/apis';
import { useMutation } from '@tanstack/react-query';
import { showSuccessNotification } from '../../../../../ui/notification';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../../../../shared/types';
import { handleError } from '../../../../../ui/err/handleError';

export default function usePutServiceOptions() {
  return useMutation(aiAgentApis.company.putAiAgentServiceOperationSettings, {
    onSuccess: () => {
      showSuccessNotification('설정 되었습니다.');
    },
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
